import { makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { EmailChangeEffects } from './email-change.effects';
import { emailChangeFeature } from './email-change.reducer';

export const provideEmailChangeFeature = () => {
  return makeEnvironmentProviders([provideState(emailChangeFeature), provideEffects(EmailChangeEffects)]);
};
